import * as ActionTypes from '../constants/actions';

const default_state = {
	activeCall : {},
	activeCallHistory: [],
	activeCallHistoryStatus : "old",
	currentActiveCall : {},
	callHistory: [],
	groupCallHistory: [],
	fetchGroupCallHistory: false,
	todayVisits: []
};

export default function therapists(state = default_state, action) {
	switch (action.type) {
		case ActionTypes.THERAPISTS.SET_ACTIVE_CALL_DATA: {
			return {
				...state,
				activeCall : action.activeCall
			};
		}
		case ActionTypes.THERAPISTS.UNSET_ACTIVE_CALL_DATA: {
			return {
				...state,
				activeCall : {}
			};
		}
		case ActionTypes.THERAPISTS.SET_ACTIVE_CALL_HISTORY: {
			return {
				...state,
				activeCallHistory : action.activeCallHistory,
				activeCallHistoryStatus: "new"
			};
		}
		case ActionTypes.THERAPISTS.UNSET_ACTIVE_CALL_HISTORY: {
			return {
				...state,
				activeCallHistory : [],
				activeCallHistoryStatus: "old"
			};
		}
		case ActionTypes.THERAPISTS.SET_CURRENT_ACTIVE_CALL: {
			return {
				...state,
				currentActiveCall : action.currentActiveCall
			};
		}
		case ActionTypes.THERAPISTS.UNSET_CURRENT_ACTIVE_CALL: {
			return {
				...state,
				currentActiveCall : {}
			};
		}
		case ActionTypes.THERAPISTS.UNSET_ACTIVE_CALL_HISTORY_FLAG: {
			return {
				...state,
				activeCallHistoryStatus: "old"
			};
		}
		case ActionTypes.THERAPISTS.SET_CALL_HISTORY: {
			return {
				...state,
				callHistory : action.callHistory
			};
		}
		case ActionTypes.THERAPISTS.UNSET_CALL_HISTORY: {
			return {
				...state,
				callHistory : []
			};
		}
		case ActionTypes.THERAPISTS.SET_GROUP_CALL_HISTORY: {
			let { groupCallHistory } = state;
			groupCallHistory = [...groupCallHistory, ...action.groupCallHistory];
			return {
				...state,
				groupCallHistory,
				fetchGroupCallHistory: false,
			};
		}
		case ActionTypes.THERAPISTS.FETCH_GROUP_CALL_HISTORY: {
			return {
				...state,
				fetchGroupCallHistory: true,
			};
		}
		case ActionTypes.THERAPISTS.UNSET_GROUP_CALL_HISTORY: {
			return {
				...state,
				groupCallHistory : [],
				fetchGroupCallHistory: false,
			};
		}

		case ActionTypes.THERAPISTS.SET_PATIENT_VISITS: {
			return {
				...state,
				todayVisits : action.todayVisits
			};
		}
		case ActionTypes.THERAPISTS.UNSET_PATIENT_VISITS: {
			return {
				...state,
				todayVisits : []
			};
		}
		default: {
			return state;
		}
	}
}
